import { render, staticRenderFns } from "./CarneDigitalItem.vue?vue&type=template&id=3b114023"
import script from "./CarneDigitalItem.vue?vue&type=script&lang=js"
export * from "./CarneDigitalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports